import React from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { error } from '@react/react-spectrum/Toast'

import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Tooltip from '@react/react-spectrum/Tooltip'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

export default function SenseiParams (props) {
    function setText (name, value) {
        const slider = {}
        slider[name] = value
        props.setParams({ ...props.params, ...slider })
    }

    try {
        return <div className="adobe-skycity-output-options">
            <Well>
                <Heading variant="pageTitle">{__('skycity_comp_title_output_options')}</Heading>
                <React.Fragment>
                    <Heading className="adobe-skycity-subtitle1" variant="subtitle1">Sensei Params</Heading>
                    <Well>
                        <div className="adobe-skycity-options-col">
                            <div className="adobe-skycity-groundingdino-option">
                                <FieldLabel className="adobe-skycity-options-field" label="text" labelFor="idText" position="left">
                                    <OverlayTrigger placement="right">
                                        <Textfield
                                            label="Text Input"
                                            defaultValue={'label'}
                                            value={props.params.text}
                                            onChange={e => setText('text', e)}
                                            id="idText"
                                        />
                                        <Tooltip variant="info">
                                            {__('output_option_tooltip_text_input_groundingdino')}
                                        </Tooltip>
                                    </OverlayTrigger>
                                </FieldLabel>
                            </div>
                            <div className="adobe-skycity-groundingdino-option">
                                <FieldLabel className="adobe-skycity-options-field" label="box_threshold" labelFor="idTemp" position="left">
                                    <OverlayTrigger placement="right">
                                        <Textfield
                                            label="Box Threshold"
                                            defaultValue={0.3}
                                            value={props.params.box_threshold}
                                            onChange={e => setText('box_threshold', e)}
                                            id="idTemp"
                                        />
                                        <Tooltip variant="info">
                                            {__('output_option_tooltip_box_threshold_groundingdino')}
                                        </Tooltip>
                                    </OverlayTrigger>
                                </FieldLabel>
                            </div>
                            <div className="adobe-skycity-groundingdino-option">
                                <FieldLabel className="adobe-skycity-options-field" label="text_threshold" labelFor="idTokens" position="left">
                                    <OverlayTrigger placement="right">
                                        <Textfield
                                            label="Text Threshold"
                                            defaultValue={0.25}
                                            value={props.params.text_threshold}
                                            onChange={e => setText('text_threshold', e)}
                                            id="idTokens"
                                        />
                                        <Tooltip variant="info">
                                            {__('output_option_tooltip_text_threshold_groundingdino')}
                                        </Tooltip>
                                    </OverlayTrigger>
                                </FieldLabel>
                            </div>
                        </div>
                    </Well>
                </React.Fragment>
            </Well>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
